module.exports = __webpack_public_path__ + "img/intro-sec01-bg.71514b35.png";